import React, { useEffect, useRef } from 'react';
import { IconArrowLeft, IconFullscreen } from './Icons';
import './DocViewer.css';

/**
 * Visualizador de documentos em tela cheia (overlay), no design system C.Vale.
 * Reutilizado pela Home e pelas telas de documentos (Fase D / CR-5).
 *
 * props:
 *  - container: nome do container do blob
 *  - file: caminho do arquivo (fullPath)
 *  - title: título exibido na barra
 *  - subtitle: linha secundária (opcional)
 *  - onClose: fecha o visualizador
 */
function DocViewer({ container, file, title, subtitle, onClose }) {
  const rootRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !document.fullscreenElement) onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
      if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
    };
  }, [onClose]);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      rootRef.current?.requestFullscreen?.().catch(() => {});
    } else {
      document.exitFullscreen().catch(() => {});
    }
  };

  const src = `/api/getDocument?container=${encodeURIComponent(container)}&file=${encodeURIComponent(file)}#toolbar=0&navpanes=0&scrollbar=0`;

  return (
    <div className="doc-viewer" ref={rootRef} role="dialog" aria-modal="true" aria-label={title}>
      <div className="doc-viewer-bar">
        <div className="doc-viewer-left">
          <button className="dv-btn" onClick={onClose} aria-label="Voltar">
            <IconArrowLeft size={16} /> Voltar
          </button>
          <div className="doc-viewer-titles">
            <span className="doc-viewer-title">{title}</span>
            {subtitle && <span className="doc-viewer-subtitle">{subtitle}</span>}
          </div>
        </div>
        <button className="dv-btn primary" onClick={toggleFullscreen} aria-label="Tela cheia">
          <IconFullscreen size={16} /> Tela Cheia
        </button>
      </div>
      <iframe
        className="doc-viewer-frame"
        src={src}
        title={title}
        allowFullScreen
        allow="fullscreen"
      />
    </div>
  );
}

export default DocViewer;
